enum ToolType {
  Arrow = "arrow",
  Diamond = "diamond",
  Ellipse = "ellipse",
  Eraser = "eraser",
  ImageLibrary = "imageLibrary", // doesn't have assigned behavior
  ImageUpload = "imageUpload", // doesn't have assigned behavior
  Line = "line",
  Marker = "marker",
  Pan = "pan",
  Pen = "pen",
  Rect = "rect",
  Select = "select",
  Stamp = "stamp", // After selecting from the image library
  Sticky = "sticky",
  Text = "text",
}
export default ToolType;
